import { toast } from 'react-hot-toast';
import { useMutation } from '@tanstack/react-query';

import { request } from '@core/api/request';
import { queryClient } from '@core/api/query-client';
import { QUERY_KEYS } from '@src/shared/constants/query-keys';
import type { TBankInfo } from '@shared/types/user';

export const editUserBankInfo = async ({
  userId,
  ...data
}: TBankInfo & { userId: number }) => {
  const id = data.id;
  return await request({
    url: id
      ? `members/${userId}/bank-accounts/${id}`
      : `members/${userId}/bank-accounts/`,
    method: id ? 'PATCH' : 'POST',
    body: data,
  });
};

export const useEditUserBankInfo = () => {
  return useMutation({
    mutationFn: editUserBankInfo,
    onError: (error: string) => {
      toast.error(error);
    },
    onSuccess: () => {
      toast.success('User Bank Info has updated successfully.');
      queryClient.invalidateQueries({
        queryKey: [QUERY_KEYS.getUserById],
      });
    },
  });
};
